type Menu = {
  name: string;
  href: string;
};

interface MenuItems {
  name: string;
  href: string;
  icon: string;
  menu?: Menu[];
}

const menuItems: MenuItems[] = [
  {
    name: "داشبورد",
    href: "/admin/dashboard",
    icon: "dashboard_admin",
  },
  {
    name: "بازاریاب",
    href: "/admin/marketers",
    icon: "users",
  },
  {
    name: "مشتری ها",
    href: "/admin/customers",
    icon: "paper",
  },

  {
    name: "کاربر حقوقی",
    href: "/admin/legal-users",
    icon: "user-circle"
  },
  {
    name: "خیریه",
    href: "/admin/charity",
    icon: "briefcase"
  },
  {
    name: "تغییر پسورد ادمین",
    href: "/admin/change-password",
    icon: "lock",
  },

  // {
  //   name: "استریت کارت",
  //   href: "/admin/street-carts",
  //   icon: "IdCardSmall"
  // },
  {
    name: "وام ها",
    href: "/admin/loan-request",
    icon: "paper",
    menu: [
      { name: "درخواست وام", href: "/admin/loan-request" },
      { name: "تعریف وام", href: "/admin/loan-definition" },
      { name: "مدیریت  اقساط", href: "/admin/loan-installments" },
    ]
  },


  {
    name: "الماس ها",
    href: "/admin/diamonds-panel",
    icon: "Diamond",
    menu: [
      {
        name: "الماس های مشتری",
        href: "/admin/diamonds-panel"
      },
      {
        name: "الماس های شرکت",
        href: "/admin/company-diamonds"
      },
      {
        name: "لیست حساب های شرکت",
        href: "/admin/list-company-diamonds"
      }
    ]
  },
  {
    name: "فروشگاه",
    href: "/admin/shop",
    icon: "basket"
  },
  {
    name: "اپلود اکسل ها",
    href: "/admin/excelUpload",
    icon: "paper",
    menu: [
      { name: "بارگذاری اکسل", href: "/admin/excelUpload" },
      { name: "لیست فایل ها", href: "/admin/excelUploads/list" },
    ],
  },
  {
    name: "مالی",
    href: "/admin/finance",
    icon: "card",
    menu: [
      {
        name: "پرداختی ها و درآمد",
        href: "/admin/finance",
      },
      {
        name: "تسویه حساب مدرسین",
        href: "/admin/finance/test",
      },
    ],
  },
  // {
  //   name: "درخواست ها",
  //   href: "/admin/requests",
  //   icon: "dollor_circle",
  // },
  // {
  //   name: "شارژها",
  //   href: "/admin/charges",
  //   icon: "charge",
  // },
  // {
  //   name: "بیمه ها",
  //   href: "/admin/insurances",
  //   icon: "check_board",
  // },
  // {
  //   name: "خدمات ما",
  //   href: "/admin/services",
  //   icon: "gift",
  //   menu: [
  //     {
  //       name: "مدیریت مقالات",
  //       href: "/admin/Article",
  //     },
  //     {
  //       name: "مدیریت دسته بندی",
  //       href: "/admin/Article/CategoryManager",
  //     },
  //   ],
  // },
  // {
  //   name: "تیکت ها",
  //   href: "/admin/tickets",
  //   icon: "monitor",
  // },
  // {
  //   name: "اعلان ها",
  //   href: "/admin/notifications",
  //   icon: "speaker",
  // },

];
export default menuItems;
